
import React from 'react'
import './PaymentSuccessComponent.css'
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";

const PaymentSuccessComponent = () => {
    const router = useNavigate();
    const [searchParams] = useSearchParams();

    const playerName = searchParams.get("player_name");
    const amount = searchParams.get("amount");
    return (
        <div className='payment_failed' style={{ flex: "1" }}>
            <div className='payment_dvi'>
                <div className='icon_div'>

                    <FaRegCheckCircle className='success_icon' />
                </div>

                {/* <hr /> */}
                <p className='payment_success_p'>Payment Success</p>

                <p className='forplayers-head-scc'>for player
                    <span className='test_pay_name'>{playerName}</span>
                </p>
                <p className='amt-head-scc'> Amount: ${amount}</p>
                <div className="trans_div">

                    <button type="button" className="common_btn btn-primary contact_banner" onClick={() => router("/")}>
                        Home
                    </button>

                </div>


            </div>

        </div >
    )
}

export default PaymentSuccessComponent
